export function countBy(data: any[], getField: (item: any) => string) {
  const counts: Record<string, number> = data.reduce((a, c) => {
    const field = getField(c);

    a[field] = (a[field] || 0) + 1;

    return a;
  }, {} as Record<string, number>);

  return Object.entries(counts).map(([value, count]) => ({ value: parseInt(value, 10), count }));
}

export function getMiddleElement<T>(array: T[]) {
  return array[Math.floor(array.length / 2)] || undefined;
}

// NOTE: https://stackoverflow.com/questions/42136098/array-groupby-in-typescript
export const groupBy = <T, K extends string | number | symbol>(array: T[], getKey: (item: T) => K) => {
  const result: Record<K, T[]> = {} as Record<K, T[]>;

  for (const item of array) {
    const key = getKey(item);

    if (!result[key]) {
      result[key] = [];
    }

    result[key].push(item);
  }

  return result;
};

export const sortBy = <T, K extends string | number | Date>(array: T[], getKey: (item: T) => K) => {
  return [...array].sort((a, b) => {
    const firstValue = getKey(a);
    const secondValue = getKey(b);

    if (firstValue === secondValue) {
      return 0;
    }

    return firstValue > secondValue ? 1 : -1;
  });
};

export const chunkBy = <T>(array: T[], size: number) => {
  const chunks: T[][] = [];

  if (size <= 0) {
    return [array];
  }

  for (let i = 0; i < array.length; i += size) {
    chunks.push(array.slice(i, i + size));
  }

  return chunks;
};
